<div class="d-flex flex-row align-items-center">
  <div class="chart-title">{{'INFLUENCER.CHART.GENDER_PER_AGE.GENDER_PER_AGE' | translate}}</div>
  <div class="tooltip-title-wrapper"><achoo-icon-tooltip [tooltipMsg]="'info_box.influencer.gender_per_age' | translate"></achoo-icon-tooltip></div>
</div>
<div class="list-container">
  <div class="d-none d-sm-block">
    <div class="d-flex flex-row list-item header justify-content-md-center justify-content-sm-center justify-content-center">
      <div class="bar-container"></div>
      <div class="text-center legend-text center-item">
        <div class="d-flex flex-row center-item align-items-center ">
          <div class="d-flex justify-content-center percentage header">{{'INFLUENCER.CHART.GENDER_PER_AGE.FEMALE' | translate}}</div>
          <div class="d-flex range-container justify-content-center text-bold grey-color-text">{{'INFLUENCER.CHART.GENDER_PER_AGE.AGE' | translate}}</div>
          <div class="d-flex justify-content-center percentage header male-text">{{'INFLUENCER.CHART.GENDER_PER_AGE.MALE' | translate}}</div>
        </div>
      </div>
      <div class="bar-container"></div>
    </div>
  </div>
  <div class="d-block d-sm-none">
    <div class="d-flex flex-row list-item header justify-content-md-center justify-content-sm-center justify-content-center">
      <div class="bar-container legend-text text-right">{{'INFLUENCER.CHART.GENDER_PER_AGE.FEMALE' | translate}}</div>
      <div class="text-center legend-text center-item">
        <div class="d-flex flex-row center-item align-items-center ">
          <div class="d-flex range-container justify-content-center text-bold grey-color-text">{{'INFLUENCER.CHART.GENDER_PER_AGE.AGE' | translate}}</div>
        </div>
      </div>
      <div class="bar-container legend-text text-left">{{'INFLUENCER.CHART.GENDER_PER_AGE.MALE' | translate}}</div>
    </div>
  </div>
  <div class="d-flex flex-row list-item" *ngFor="let item of chartData">
    <div class="bar-container">
      <div class="bar blue pull-right"
        [style.width.%]="(item.f/maxPercent)*100"
        [style.backgroundColor]="barFemaleColor"
        [ngClass]="{'placholder-bg-color' : isPlaceholder === true}">

        <span class="d-block d-sm-none percent-mobile percent-mobile-left">
          <span *ngIf="!isPlaceholder">{{item.f}}%</span>
          <span *ngIf="isPlaceholder"> - %</span>
        </span>
      </div>
    </div>
    <div class="text-center center-item">
      <div class="d-flex flex-row align-items-center full-height">
        <div class="d-flex justify-content-center percentage">
          <span *ngIf="!isPlaceholder">{{item.f}}%</span>
          <span *ngIf="isPlaceholder"> - %</span>
        </div>
        <div class="d-flex range-container justify-content-center">
          <div class="range">{{item.range}}</div>
        </div>
        <div class="d-flex justify-content-center percentage">
          <span *ngIf="!isPlaceholder">{{item.m}}%</span>
          <span *ngIf="isPlaceholder"> - %</span>
        </div>
      </div>
    </div>
    <div class="bar-container">
      <div class="bar green pull-left"
        [style.width.%]="(item.m/maxPercent)*100"
        [style.backgroundColor]="barMaleColor"
        [ngClass]="{'placholder-bg-color' : isPlaceholder === true}">

        <span class="d-block d-sm-none percent-mobile percent-mobile-right">
          <span *ngIf="!isPlaceholder">{{item.m}}%</span>
          <span *ngIf="isPlaceholder"> - %</span>
        </span>
      </div>

    </div>
  </div>
  <div class="d-none d-sm-block">
    <div class="row list-item x-axis-legend ">
      <div class="col-sm-5 bar-container">
        <div class="row x-axis-container">
          <div class="col-sm no-padding x-axis" *ngFor="let item of leftXAxis">
            <span *ngIf="(item % 10 === 0)">{{item}}</span>
          </div>
        </div>
      </div>
      <div class="col-sm-2 text-center">
        <div class="row x-axis-container center-legend">
          <div class="col-sm no-padding x-axis">
            %
          </div>
        </div>
      </div>
      <div class="col-sm-5 bar-container">
        <div class="row x-axis-container">
          <div class="col-sm no-padding x-axis" *ngFor="let item of rightXAxis">
            <span *ngIf="(item % 10 === 0)">{{item}}</span>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>



// WEBPACK FOOTER //
// ./src/app/main/influencer/influencer-demographics/gender-per-age-chart/gender-per-age-chart.component.html